import React from 'react';
import PropTypes from 'prop-types';
import TextField from './TextField';
import styles from '../BacsPaymentStyles';
import withIsActive from '../../../../containers/withIsActive';

const PaymentName = ({ id, maxLength, onBlur, onFocus, paymentName, description, isActive }) => (
	<div>
		<TextField id={id} value={paymentName} onBlur={onBlur} onFocus={onFocus} maxLength={maxLength} />
		{isActive && (
			<span id="paymentNameToggledDescription" className={styles.main__description}>
				{description}
			</span>
		)}
	</div>
);

PaymentName.defaultProps = {
	onFocus: () => {},
};

PaymentName.propTypes = {
	id: PropTypes.string.isRequired,
	paymentName: PropTypes.string,
	onBlur: PropTypes.func.isRequired,
	onFocus: PropTypes.func,
	maxLength: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	isActive: PropTypes.bool.isRequired,
};

export default withIsActive(PaymentName);
